<main-header></main-header>
<main>
    <div class="container">
        <div class="top-part">
            <div class="breadcrumb">
                <import-navigator currentStep="dimensions"></import-navigator>
                <div class="wrap-text">
                    <b>
                        Define analysis dimensions
                    </b>
                    <span>
                        e.g. by “Country”, “Product”, etc.
                    </span>
                </div>
            </div>
        </div>
        <div [ngClass]="{'loading':!dataLoaded, 'middle-part' :true, 'set-up':true}">
            <div class="current-status">
                <div class="left">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot green"></div>
                </div>
                <div class="divider"></div>
                <div class="right">
                    <div class="wrap">
                        Out of the {{numOfCombinations}} different combinations of the values of the {{numOfDimensions}} dimensions you selected ({{dimensionsNames}}), {{numOfNotUniqueCombinations}} combinations ({{percOfNotUniqueCombinations}}% of total) include more than one record for {{oldControlColumnValue}} or {{newControlColumnValue}} ⓘ; <span *ngIf="percOfBothControlValuesCombinations <= 40">also, only {{numOfBothControlValuesCombinations}} combinations ({{percOfBothControlValuesCombinations}}% of total) include one record for both {{oldControlColumnValue}} and {{newControlColumnValue}} ⓘ.</span>  Select a strategy to continue:
                    </div>
                    <div class="wrap">
                        <div class="radio-column">
                            <form [formGroup]="form">
                                <div class="form-choice">
                                    <input type="radio"(change)="radioChange($event)" id="strat1" formControlName="strategy" name="strategy" [value]="1" class="form-choice-radio">
                                    <label class="form-choice-label" for="strat1">
                                        Only analyse {{outcomeColumnName}} variance<br>
                                        <small>Disregard {{otherFormulaComponentsNames}} variance</small>
                                    </label>
                                </div>
                                <div class="form-choice">
                                    <input type="radio"(change)="radioChange($event)" id="strat2" formControlName="strategy" name="strategy" [value]="2" class="form-choice-radio">
                                    <label class="form-choice-label" for="strat2">
                                        Go back and re-upload corrected data<br>
                                        <small>It is highly recommended to work with a dataset that for all relevant analysis combinations includes ONE record for {{oldControlColumnValue}} and ONE for {{newControlColumnValue}}</small>
                                    </label>
                                </div>
                                <div class="form-choice">
                                    <input type="radio"(change)="radioChange($event)" id="strat3" formControlName="strategy" name="strategy" [value]="3" class="form-choice-radio">
                                    <label class="form-choice-label" for="strat3">
                                        Select additional dimensions manually to reduce the combinations with multiple records <help-link helpId="36"></help-link><br>
                                        <small>This strategy will further reduce the number of combinations that include one record for both {{oldControlColumnValue}} and {{newControlColumnValue}} and can be compared across</small>
                                    </label>
                                </div>
                                <div class="form-choice" *ngIf="availableStrategies && availableStrategies.indexOf(PreaggregationStrategy.autoSelectBackDimensions) > -1">
                                    <input type="radio"(change)="radioChange($event)" id="strat4" formControlName="strategy" name="strategy" [value]="4" class="form-choice-radio">
                                    <label class="form-choice-label" for="strat4">
                                        Let the system automatically select additional dimensions in the background as needed <help-link helpId="37"></help-link><br>
                                        <small>This strategy will further reduce the number of combinations that include one record for both {{oldControlColumnValue}} and {{newControlColumnValue}} and can be compared across</small>
                                    </label>
                                </div>
                                <div class="form-choice">
                                    <input type="radio"(change)="radioChange($event)" id="strat5" formControlName="strategy" name="strategy" [value]="5" class="form-choice-radio">
                                    <label class="form-choice-label" for="strat5">
                                        Sum up <span *ngIf="summedColumnNames">{{summedColumnNames}}</span> and average up {{averagedColumnNames}} <span *ngIf="!weightColumnName">not weighted</span><span *ngIf="weightColumnName">weighted by {{weightColumnName}}</span> <span *ngIf="form.controls.strategy.value == 5">:</span> <br *ngIf="this.form.controls.strategy.value == 5" />
                                        <span *ngIf="form.controls.strategy.value == 5">click <button (click)="startSelectingColumnsToSum()" [ngClass]="{'loading-small':loading, 'btn':true, 'btn-gray':true, 'btn-small':true }">here</button> to re-select the dimensions to sum up, and <button (click)="startSelectingWeightColumn()" [ngClass]="{'loading-small':loading, 'btn':true, 'btn-gray':true, 'btn-small':true }">here</button> for the dimension to weight the averages</span><br>
                                        <small>This is a stretched option to get a read into the contribution of each {{outcomeColumnName}} driver: it is valid, yet not broadly recommended</small>
                                    </label>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div *ngIf="false" class="wrap-table">
                        <div class="block-table">
                            <div class="table mb-16 text-left">
                                <table class="table-minimal">
                                    <thead>
                                        <tr>
                                            <th><b>Component</b>


                                            </th>
                                            <th>Sum or<br> average</th>
                                            <th>Weight</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="border-bottom">
                                            <td>
                                                <ul class="ellipses-tree_one-select ellipses ellipses-root ellipses-tree">
                                                    <li>
                                                        <div content="Revenue" class="ellipse small bg-white color-gray border-gray"><b class="ellipse-text">Revenue</b></div>
                                                    </li>
                                                </ul>
                                            </td>
                                            <td><b>Sum</b></td>

                                            <td><b>None</b></td>



                                        </tr>
                                        <tr>
                                            <td>
                                                <ul class="ellipses-tree_one-select ellipses ellipses-root ellipses-tree">
                                                    <li>
                                                        <ul class="ellipses">
                                                            <li>
                                                                <div content="Price" class="ellipse small bg-white color-gray border-gray"><b class="ellipse-text">Price</b></div>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </td>
                                            <td>Sum</td>

                                            <td>None</td>



                                        </tr>


                                        <tr>
                                            <td>
                                                <ul class="ellipses-tree_one-select ellipses ellipses-root ellipses-tree">
                                                    <li>
                                                        <ul class="ellipses">
                                                            <li>
                                                                <div content="Volume" class="active ellipse small bg-white color-gray border-gray"><b class="ellipse-text">Volume</b></div>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </td>
                                            <td>Average</td>

                                            <td>Volume</td>



                                        </tr>
                                        <tr class="border-bottom">
                                            <td>
                                                <ul class="ellipses-tree_one-select ellipses ellipses-root ellipses-tree">
                                                    <li>
                                                        <ul class="ellipses">
                                                            <li>
                                                                <ul class="ellipses">
                                                                    <li>
                                                                        <div content="New" class="ellipse small bg-white color-gray border-gray"><b class="ellipse-text">New</b></div>
                                                                    </li>
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </td>
                                            <td> Average </td>

                                            <td> Volume </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <p>
                                <a href>Weight all averaged metrics</a> by Discount weighting
                            </p>

                            <div class="btn-group mt-16">
                                <button class="btn btn-green btn-small">Done</button>
                                <button class="btn btn-gray btn-small">Cancel</button>
                            </div>
                        </div>
                    </div>
                    <div class="wrap">
                        <button autofocus (click)="selectStrategy()" [ngClass]="{'loading-small':loading, 'btn':true, 'btn-green':true, 'btn-small':true, 'ml-32':true }">Continue</button>
                    </div>

                </div>
            </div>

            <div *ngIf="this.form.controls.strategy.value == 5 && (selectingWeightColumn || selectingColumnsToSum)" class="table-data">
                <table>
                    <thead>
                    <tr>
                        <th *ngFor="let col of columns" (click)="columnClick(col)" [ngClass]="{'eligible': (selectingWeightColumn && col.isEligible || selectingColumnsToSum && col.isEligibleAlt), 'selected': (selectingWeightColumn && col.isSelected || selectingColumnsToSum && col.isSelectedAlt)}">
                            {{col.name}}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="small-font">
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'selected': col.isSelected}">
                            <ng-container *ngIf="col.isNumerical">
                                <b class="green">#</b>,&nbsp;
                            </ng-container>
                            {{ displayRoughNum(col.uniqueValues) }}
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length">
                                <div class="gray">
                                    {{col.someVals[0]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length > 1">
                                <div class="gray">
                                    {{col.someVals[1]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length > 2">
                                <div class="gray">
                                    {{col.someVals[2]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length > 3">
                                <div class="gray">
                                    {{col.someVals[3]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length > 4">
                                <div class="gray">
                                    {{col.someVals[4]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</main>
